export default __webpack_public_path__ + "d5df90fcc8e5e66e52b24c55011e2b0e.svg";